import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const prefs = localStorage.getItem('cookie-prefs');
    if (!prefs) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-prefs', JSON.stringify({ essential: true, analytics: true }));
    setVisible(false);
    window.location.reload();
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Utilizamos cookies propias y de terceros para analizar el tráfico y mejorar tu experiencia.
      </p>
      <div className="cookie-actions">
        <button onClick={acceptCookies}>Aceptar</button>
        <Link to="/configurar-cookies">Configurar cookies</Link>
      </div>
    </div>
  );
}

export default CookieBanner;
